
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

/**
 * Deletes a suggestion by ID from the Supabase database
 * @param id - ID of the suggestion to delete
 * @returns Promise that resolves when the operation is complete
 * @throws Error if the deletion fails
 */
export const deleteSuggestion = async (id: string): Promise<void> => {
  console.log(`Attempting to delete suggestion with ID: ${id}`);
  
  // Make sure the ID is valid
  if (!id || typeof id !== 'string') {
    console.error('Invalid suggestion ID for deletion');
    const error = new Error('Kunne ikke slette tipset. Ugyldig ID.');
    toast.error(error.message);
    throw error;
  }

  // Delete the suggestion from Supabase and get the deleted data back
  const { data, error, count } = await supabase
    .from('suggestions')
    .delete()
    .eq('id', id)
    .select();
  
  if (error) {
    console.error('Error deleting suggestion:', error);
    const deleteError = new Error('Kunne ikke slette tipset. Feil ved databaseforespørsel.');
    toast.error(deleteError.message);
    throw deleteError;
  }
  
  // Check if any rows were actually deleted
  if (!data || data.length === 0) {
    console.error(`No suggestion found with ID: ${id} or deletion was prevented`);
    const notFoundError = new Error('Kunne ikke slette tipset. Tipset ble ikke funnet eller du har ikke tilgang til å slette det.');
    toast.error(notFoundError.message);
    throw notFoundError;
  }
  
  console.log(`Successfully deleted suggestion with ID: ${id}`, data);
  toast.success('Tipset ble slettet');
};
